import styled from 'styled-components'

export const CustomPhysiologyContainer = styled.ul`
  font-size: 16px;
  line-height: 22px;
  color: var(--grey2);
  list-style-position: inside;
  margin-top: 2rem;
`
